import Marionette from 'backbone.marionette';
import Navigator from '../../app';
// import welcomeController from './welcome_controller';

const WelcomeRouter = Marionette.AppRouter.extend({
  appRoutes: {
    "welcome": "showWelcome",
    "": "showWelcome"
  }
});
const API = {
  showWelcome: function () {
    import( /* webpackChunkName: "welcome" */'./welcome_controller').then(module => {
      const welcomeController = module.default;
      welcomeController.showWelcome();
    });
    // welcomeController.showWelcome();
  }
};

Navigator.vent.on("welcome:show", function () {
  if (window.location.hash) {
    // don't navigate if we are already on the welcome page, that causes issues with handling URL updates between parent and child iframe
    Navigator.navigate("");
  }
  API.showWelcome();
});
Navigator.on("before:start", function () {
  new WelcomeRouter({
    controller: API
  });
});
export { WelcomeRouter as default };